import NewBusinessServiceDialog from '@/components/purchase_policy/NewBusinessServiceDialog.vue'
export default {
    components: {
        NewBusinessServiceDialog
    },
    name: 'NewBusinessRegisteredService',
    props: {
        title: String,
        instruction: String
    },
    data() {
        return {
            hasSearchKeyword: false,
            baseURL : window.location.origin,
            find_your_service: '',
            descriptionLimit: 60,
            entries: [],
            isLoading: false,
            model: null,
            search: null,
            filter_search_entry: "Service Name / Location",
            searchOptions: ['Service Name / Location', 'Service Approval Number'],
            loading: false,
            is_timeout: 0,
            token: document.getElementsByName('cmb-api-token')[0].content,
            token_name: "cmb-auth",
            dataSource: [],
            search_temp_ids : [],
            search_temp_array: [],
            search_temp_paginated: [],
            doneSearch: false,
            search_temp_array_bk_up : [],
            handle_scroll_activated: false,
            registeredServiceSubmitted: false,
        }
    },
    watch: {
        find_your_service: function(val) {
            if(val.length > 3) {
                this.hasSearchKeyword = true;
            } else {
                this.hasSearchKeyword = false;
            }
        }
    },
    computed: {
        fetchResultBySearchByAddress() {
            return {
                method: 'get',
                url: this.baseURL + '/service/search_by_address.json',
                params: {
                    keyword: this.find_your_service,
                    token: this.token,
                    token_name: this.token_name
                }
            }
        },
        fetchResultBySearchByServiceName() {
            return {
                method: 'get',
                url: this.baseURL + '/service/search_by_service_name.json',
                params: {
                    keyword: this.find_your_service,
                    token: this.token,
                    token_name: this.token_name
                }
            }
        },
        fetchResultByServiceByApprovalNumber() {
            return {
                method: 'get',
                url: this.baseURL + '/service/search_by_service_approval_number.json',
                params: {
                    keyword: this.find_your_service,
                    token: this.token,
                    token_name: this.token_name
                }
            }
        },
        fetchResultByPostCode() {
            return {
                method: 'get',
                url: this.baseURL + '/service/search_by_post_code.json',
                keyword: this.find_your_service,
                token: this.token,
                token_name: this.token_name
            }
        }
    },
    methods: {
        isEmpty(obj) {
            for(var key in obj) {
                if(obj.hasOwnProperty(key))
                    return false;
            }
            return true;
        },
        checkStoreData() {
            console.debug('Payload Build Structure', this.$store.getters.sessionPayload);
        },
        
        initApp() {
            this.checkStoreData();
        },

        backToPrevious() {
            this.$store.commit('mutate', {
                property: "NewBusinessStep",
                value: this.$store.state.NewBusinessStep - 1
            });
        },

        async fetchSearchedKeywordResults(action_url) {
            let response = await this.$store.dispatch('fetchData', this.fetchGeneratedDetailsFromSearchPayload)
        },

        resetData(){
            //this.dataSource = [];
            this.counter = 0;
            this.search_temp_paginated  = [];
            this.search_temp_ids = [];
            this.search_array_two_words = [];
            this.dataSource = [];
            
        },

        selectService(item){
            let saveRegisteredServiceDetail = {
                id: item.id,
                suburb: item.suburb,
                address_lookup: item.search_address,
                postcode: item.post_code,
                service_name: item.service_name,
                address_line_1: item.address_line_1,
                address_line_2: item.address_2,
                service_approval_number: item.service_approval_number,
                state: item.state,
                company_name: item.company_name
            }

            this.$store.commit('mutate', {
                property: "sessionDetails.properties.registered_service",
                value: saveRegisteredServiceDetail
            });
        },
        handleChange(){
            this.find_your_service = "";
            this.resetData();
            this.search_temp_array_bk_up = [];
            this.hasSearchKeyword = false;
        },

        async generateOptionListBasedOnLookup(lookupType) {

            let filteredResultSearch = await this.$store.dispatch('fetchData', lookupType);
            let search_temp_paginated = []
            if(filteredResultSearch) {
                if(filteredResultSearch.data.items.results.length > 0) {
                    let searchedResults = filteredResultSearch.data.items.results;
                    searchedResults.forEach(function(data) {
                        search_temp_paginated.push(data);
                    });
                }
            }

            return search_temp_paginated
        },

        checkDuplicateData(search_arr){
            let temp_array = [];
            let temp_ids = [];
            for(let j=0; j < search_arr.length; j++){
                if(search_arr[j].id) {
                    if(temp_ids.indexOf(search_arr[j].id) == -1) {
                        temp_array.push(search_arr[j]);
                        temp_ids.push(search_arr[j].id);
                    }
                }
            }  
            
            let return_data = {
                "temp_array" : temp_array,
                "temp_ids" : temp_ids
            };

            return return_data;

        },

        async filterMoreKeywords(_search_array_keyword){
            //this.loading = true;
            let i=0;
            let final_array = this.search_temp_array_bk_up;
            this.search_array_two_words = [];

            for(i=0; i < _search_array_keyword.length; i++){
                
                let temp_array = final_array.filter(obj => Object.keys(obj).some(
                    key => obj[key].toLowerCase().includes(_search_array_keyword[i].toLowerCase())
                ));
                final_array = temp_array;
            }
            this.search_array_two_words = final_array;
            //this.loading = false;
            return final_array;
        },

        async showResults(filteredData){

            let _wherefrom="showResults";
            if(filteredData.morethantwo == true){
                this.search_temp_ids = filteredData.temp_ids;
                this.search_temp_array_bk_up = this.search_temp_array = filteredData.temp_array;
                let return_data_ = await this.filterMoreKeywords(filteredData.array_keyword);
                await this.lazyloading(return_data_,  _wherefrom="showResults", filteredData.temp_keyword);
            }else{
                this.search_temp_ids = filteredData.temp_ids;
                this.search_temp_array_bk_up = this.search_temp_array = filteredData.temp_array;
                await this.lazyloading(filteredData.temp_array,_wherefrom ,filteredData.temp_keyword);
            }
        },

        async lazyloading(return_data, _wherefrom, _keyword){
            let plus_;

            if(return_data.length <= 4){
                plus_ = (return_data).length;
            }else{
                plus_ = 5;
            }

            let countr_ = this.counter + plus_;
            let y=0;
            
            if(this.search_temp_paginated.length == 5 ){
                if(_keyword){
                    if(this.find_your_service != _keyword){
                        this.dataSource = [],
                        this.resetData(),
                        this.counter = 0,
                        this.search_temp_array_bk_up = [],
                        this.search_temp_array = [],
                        this.search_temp_paginated = [];
                        let reset = true;
                        this.getServiceList(reset);

                    }else{
                        this.search_temp_paginated=  [];
                        await this.lazyloadingData(return_data, countr_);
                        this.loading = false;
                    }
                    
                }else{
                    await this.lazyloadingData(return_data, countr_);
                    this.loading = false;
                }
            }else{
                if(_keyword){
                    if(this.find_your_service != _keyword){
                        this.dataSource = [],
                        this.resetData(),
                        this.counter = 0,
                        this.search_temp_array_bk_up = [],
                        this.search_temp_array = [],
                        this.search_temp_paginated = []
                        let reset = true;
                        this.getServiceList(reset);
                    }
                }else{
                    await this.lazyloadingData(return_data, countr_);
                }
                if(return_data.length >= 5){
                    await this.lazyloadingData(return_data, countr_);
                    this.dataSource = this.search_temp_paginated;
                    
                    
                }else{
                    this.dataSource = return_data;
                
                }
                this.loading = false;
            }
        },
        htmlEntities(str) {
            return str.replace('&amp;', '&' ).replace('&lt;' , '<').replace('&gt;' , '>').replace('&quot;' , '"');
        },
        filter(_keyword, _obj) {
            //this.loading = true;
            let return_data = _obj.filter(obj => Object.keys(obj).some(key => obj[key].toLowerCase().includes(_keyword.toLowerCase())));
            //this.loading = false;
            return return_data;
        },
        filterID(_keyword, _obj) {
            return _obj.findIndex(x => x.id === _keyword);
        },
        async lazyloadingData(return_data, countr_){
            if(return_data.length > this.counter){
                while(this.counter < countr_){
                    if(return_data[this.counter]){ /* !== undefined || data[this.counter].id != undefined */ 
                        if(this.filterID(return_data[this.counter].id,this.search_temp_paginated) == -1){
                            return_data[this.counter].service_name = this.htmlEntities(return_data[this.counter].service_name);
                            return_data[this.counter].address_line_1 = this.htmlEntities(return_data[this.counter].address_line_1);
                            return_data[this.counter].address_line_1 = this.htmlEntities(return_data[this.counter].address_line_1);
                            (this.search_temp_paginated).push(return_data[this.counter]); 
                        }
                    }else{
                        
                    }
                    this.counter++;
                }

                let self = this;
                setTimeout(() => {
                    if(self.dataSource.length > 0){
                        let elem1 = document.getElementById("scrolly");
                        let hey = elem1.addEventListener('scroll', self.handleScroll);
                        
                        this.handle_scroll_activated = true;
                    }
                }, 300);
            }else{
                if(this.handle_scroll_activated){
                    let elem1 = document.getElementById("scrolly");
                    elem1.removeEventListener('scroll', this.handleScroll);
                }
               
            }
            this.dataSource = this.search_temp_paginated;
        },

        handleScroll(){
            let el = document.getElementById("scrolly");
            let el_compute = el.scrollHeight - el.scrollTop;
            if(el_compute < 346){
                let _wherefrom="handleScroll";
                this.lazyloading(this.search_temp_array, _wherefrom);
            }
        },

        async search_word(_keyword, morethantwo, keyword_split){
            this.loading = true;
            let search_arr = []
            if(this.filter_search_entry == 'Service Name / Location') {

                const searchByAddress =  await this.generateOptionListBasedOnLookup(this.fetchResultBySearchByAddress);
                const searchByServiceName =  await this.generateOptionListBasedOnLookup(this.fetchResultBySearchByServiceName);

                search_arr = [
                    ...searchByAddress,
                    ...searchByServiceName
                ]

            } else {
                const searchByServiceApprovalNumber = await this.generateOptionListBasedOnLookup(this.fetchResultByServiceByApprovalNumber);
                search_arr = [...searchByServiceApprovalNumber]
            }

            let filteredData = this.checkDuplicateData(search_arr);
                filteredData['morethantwo'] = morethantwo;
                filteredData['temp_keyword'] = _keyword;
                filteredData['array_keyword'] = keyword_split;
                await this.showResults(filteredData);
                
        },

        async getServiceList(reset=false) {
            this.doneSearch = false;
            let _keyword = this.find_your_service,
                keyword_split = _keyword.split(" "),
                keyword_split_len = keyword_split.filter(function(v){return v!==''});

            if (this.find_your_service.length <=3 ){
                this.resetData();
            }
            else if((this.find_your_service).length == 4 ) {
                this.resetData();
                
                //1 word
                if(keyword_split.length == 1){
                    let morethantwo = false;
                    await this.search_word(_keyword, morethantwo, keyword_split);
                }
                //2 words
                else{
                    let morethantwo = true;
                    await this.search_word(_keyword, morethantwo, keyword_split);
                }
            }else if((this.find_your_service).length >= 5){
                    if(keyword_split.length == 1){
                        if((_keyword).includes(this.search_keyword) == true){
                            if(reset == true){
                                this.dataSource = [];
                                this.resetData();
                                this.search_temp_array_bk_up = [];
                                this.search_temp_paginated = [];
                                this.search_temp_array = [];
                                //temporary trim cause infinite loop here
                                let morethantwo=false;
                                await this.search_word(_keyword, morethantwo, keyword_split);
                            }else{
                                this.counter = 0;
                                this.search_temp_paginated = [];
                                this.search_array_two_words = [];
                                let response = this.filter(_keyword , this.search_temp_array_bk_up);
                                await this.lazyloading(response, _wherefrom="word_includes");
                            }
                        }
                        else {
                            this.counter = 0;
                            this.dataSource = [];
                            this.search_temp_ids = [];
                            this.resetData();
                            await this.search_word (_keyword, keyword_split=keyword_split);      
                        }
                    }
                    else{
                        
                        if((this.dataSource).length != 0){
                            let data_ = await this.filterMoreKeywords(keyword_split_len);
                            this.search_temp_paginated = [];
                            await this.lazyloading(data_);
                            this.counter = 0;
                        }
                        
                        else{
                            this.dataSource = [];
                            this.resetData();
                            this.search_temp_array_bk_up = [];
                            this.search_temp_paginated = [];
                            this.search_temp_array = [];
                            let morethantwo=true;
                            await this.search_word(_keyword, morethantwo,keyword_split=keyword_split);
                        }
                    }
            }

            this.doneSearch = true;
        },
        submitForm() {
            this.registeredServiceSubmitted = true;
            this.$emit("createUpdateSession");
        },
        openDialog(mode="ADD") {
            this.mode=mode
            this.$store.commit('mutate', {
                property: "NewBusinessServiceDialog",
                value: true
            });
        },
        deleteRegisteredAddress() {
            this.$store.commit('mutate', {
                property: "sessionDetails.properties.registered_service",
                value: null
            });
        }
    },
    mounted() {
        this.initApp();
    }
}

